import { render, staticRenderFns } from "./producttab.vue?vue&type=template&id=3b39fb9e&scoped=true&"
import script from "./producttab.vue?vue&type=script&lang=js&"
export * from "./producttab.vue?vue&type=script&lang=js&"
import style0 from "./producttab.vue?vue&type=style&index=0&id=3b39fb9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b39fb9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b39fb9e')) {
      api.createRecord('3b39fb9e', component.options)
    } else {
      api.reload('3b39fb9e', component.options)
    }
    module.hot.accept("./producttab.vue?vue&type=template&id=3b39fb9e&scoped=true&", function () {
      api.rerender('3b39fb9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/physical/producttab.vue"
export default component.exports